import RootState from '@/store/rootState';

export default {
    applications: [],
    arbiterZones: [],
    zetaHubZones: [],
    availableVehicleTypeActions: [],
    availableVehicleTypes: [],
    barns: [],
    cropTypes: [],
    errors: [],
    farms: [],
    feedTypes: [],
    fences: [],
    groundTypes: [],
    locales: [],
    modules: [],
    timeZones: [],
    users: [],
    vehicleActions: [],
    vehicleTypes: [],
    vehicles: [],
    userGroups: [],
    farmGroups: [],
    roles: [],
    relayServers: [],
} as RootState;
